import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

/*
  Generated class for the UsuarioServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class UsuarioServiceProvider {

  constructor(public http: HttpClient) {
    console.log('Hello UsuarioServiceProvider Provider');
  }

}



// WEBPACK FOOTER //
// ./src/providers/usuario-service/usuario-service.ts